import * as React from "react";

import type { Message } from "./ChatContextTypes";
import type { AskNeedlTools } from "@/types/api";

// Simplified chat state interface - sessions removed
export interface ChatState {
  sessionId: string;
  messages: Message[];
  input: string;
  tools: AskNeedlTools | null;
  reportType: string | null;
  sessionTitle: string | null;
  isArtifactReportSchedulingMessageDisabled: boolean;
}

// Custom hook for managing simplified chat state
export const useChatState = () => {
  const [sessionId, setSessionId] = React.useState<string>("");
  const [messages, setMessages] = React.useState<Message[]>([]);
  const [input, setInput] = React.useState<string>("");
  const [tools, setTools] = React.useState<AskNeedlTools | null>(null);
  const [reportType, setReportType] = React.useState<string | null>(null);
  const [sessionTitle, setSessionTitle] = React.useState<string | null>(null);
  const [
    isArtifactReportSchedulingMessageDisabled,
    setIsArtifactReportSchedulingMessageDisabled,
  ] = React.useState<boolean>(false);

  const state: ChatState = {
    sessionId,
    messages,
    input,
    tools,
    reportType,
    sessionTitle,
    isArtifactReportSchedulingMessageDisabled,
  };

  const setters = {
    setSessionId,
    setMessages,
    setInput,
    setTools,
    setReportType,
    setSessionTitle,
    setIsArtifactReportSchedulingMessageDisabled,
  };

  return { state, setters };
};
